<template>
  <v-menu
    v-model="datetimeOpen"
    :max-width="520"
    :min-width="520"
    :close-on-content-click="false"
    content-class="UXDatapicker"
  >
    <template v-slot:activator="{ on }">
      <div class="UXdatetimeInput" :class="{ 'outline' : !isOutline }" v-on="on">
        <span v-if="isDateStringFormat">{{ picker ? picker : '0000-00-00'}}  {{ hour ? hour : '00' }}時 {{ minut ? minut : '00' }}分</span>
        <span v-else>{{ picker ? picker : '0000-00-00'}}  {{ hour ? hour : '00' }}:{{ minut ? minut : '00' }}</span>
        <input type="hidden" v-model="value" />
        <i class="UXicon-down"></i>
      </div>
    </template>

    <v-card class="UXdtpCard">
      <div class="head">
        <p>
          <strong>
            {{ picker ? picker : '日付選択'}}
            <span v-if="hour || minut">
              {{ hour ? hour + '時 ' : '' }}
              {{ minut ? minut + '分 ' : '' }}
              </span>
            <span v-else>時間選択</span>
          </strong>
        </p>
        <div class="endBtn" v-if="picker && hour && minut">
          <v-btn dark color="#ff8c8c" @click="setDataTime">
            完了
          </v-btn>
        </div>
      </div>
      <div class="con">
        <div class="datePickerBox">
          <FunctionalCalendar
            ref="funCalendar"
            v-model="calendarData"
            :configs="calendarConfigs"
          ></FunctionalCalendar>
        </div>
<!--        <v-date-picker v-model="picker" :weekday-format="getDay" width="260" no-title></v-date-picker>-->
        <div class="timeBox">
          <dl>
            <dt>{{ hour ? hour : '00' }}時</dt>
            <dd>
              <perfect-scrollbar>
                <ul>
                  <li v-for="(item, index) in hours" :key="index">
                    <a :class="{on: hour == item}" @click="hour = item">{{ item }}時</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
          <dl>
            <dt>{{ minut ? minut : '00' }}分</dt>
            <dd>
              <perfect-scrollbar>
                <ul v-if="!(hour === 24 || hour === '24')">
                  <li v-for="(item, index) in minutes" :key="index">
                    <a :class="{on: minut == item}" @click="minut = item">{{ item }}分</a>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <a :class="{on: minut == '00'}" @click="minut = '00'">00分</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { FunctionalCalendar } from 'vue-functional-calendar'

export default {
  name: 'dateTimePicker',
  components: {
    FunctionalCalendar
  },
  data () {
    return {
      calendarData: {},
      calendarConfigs: {
        sundayStart: true,
        isDatePicker: true,
        calendarsCount: 1,
        hiddenElements: ['leftAndRightDays'],
        dateFormat: 'yyyy-mm-dd',
        dayNames: ['月', '火', '水', '木', '金', '土', '日'],
        monthNames: ['.01', '.02', '.03', '.04', '.05', '.06', '.07', '.08', '.09', '.10', '.11', '.12']
      },
      datetimeOpen: false,
      picker: '',
      hours: [],
      minutes: [],
      hour: '',
      minut: ''
    }
  },
  props: {
    value: {
      type: String,
      required: false
    },
    minutScope: {
      type: Number,
      required: false
    },
    isDateStringFormat: {
      type: Boolean,
      default: true,
      required: false
    },
    isOutline: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  watch: {
    datetimeOpen (val) {
      this.resetDataTime()
    },
    calendarData: {
      deep: true,
      handler (val) {
        if (val.selectedDate) {
          this.picker = this.isDateOut(val.selectedDate)
        }
      }
    },
    value (val) {
      this.resetDataTime()
    }
  },
  created () {
    const minuteScopeNum = !this.minutScope ? 5 : this.minutScope < 60 ? this.minutScope : 5
    for (let i = 0; i < 60; i++) {
      let num = i.toString().length > 1 ? i : '0' + i.toString()
      if (this.hours.length <= 24 && i >= 0) {
        this.hours.push(num)
      }
      if (i % minuteScopeNum === 0) {
        this.minutes.push(num)
      }
    }

    setTimeout(() => {
      this.resetDataTime()
    }, 50)
  },
  methods: {
    isDateIn (val) {
      let date = val.split('-').map(k => k.toString()[0] === '0' ? k.replace('0', '') : k)
      return date[0] + '-' + date[1] + '-' + date[2]
    },
    isDateOut (val) {
      let date = val.split('-').map(k => k.toString().length === 1 ? '0' + k : k)
      return date[0] + '-' + date[1] + '-' + date[2]
    },
    isDateConvert (val) {
      if (val) {
        let date = val.split('-').map(k => k.toString().length === 1 ? '0' + k : k)
        if (['01', '02', '03', '04', '05', '06', '07', '08', '09'].includes(date[1])) {
          date[1] = date[1][1]
        }
        if (['01', '02', '03', '04', '05', '06', '07', '08', '09'].includes(date[2])) {
          date[2] = date[2][1]
        }
        return date[0] + '-' + date[1] + '-' + date[2]
      }
    },
    resetDataTime () {
      if (this.value && this.$refs.funCalendar) {
        this.$nextTick(() => {
          let date = this.value.split(' ')
          this.$refs.funCalendar.ChooseDate(this.isDateIn(date[0]))
          this.$refs.funCalendar.singleSelectedDate = this.isDateIn(date[0])
          this.picker = this.isDateOut(date[0])
          if (this.calendarData) {
            this.calendarData['selectedDate'] = this.isDateConvert(date[0])
          }
          if (date[1]) {
            let time = date[1].split(':')
            this.hour = time[0]
            this.minut = time[1]
          }
        })
      }
    },
    setDataTime () {
      this.$emit('input', this.picker + ' ' + this.hour + ':' + this.minut)
      this.datetimeOpen = false
    },
    getDay (date) {
      const daysOfWeek = ['月', '火', '水', '木', '金', '土', '日']
      return daysOfWeek[new Date(date).getDay(date)]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DateTimePicker.vue